<template>
  <div id="page" style="height:100%">
    <!-- <div id="img1" class="img"></div>
    <div id="img2" class="img"></div> -->
    <div id="logo" class="img"></div>
    <!-- <div class="head">
      上勘算法平台
    </div> -->
    <div id="mainTab">
    <a-tabs default-active-key="1" id="login_tab">
      <!-- 登陆 -->
      <a-tab-pane key="1" tab="登录">
        <a-form-model
          ref="loginForm"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          :model="loginForm"
          :rules="loginRules"
        >
          <a-form-model-item label="邮箱" prop="email">
            <a-input v-model="loginForm.email" />
          </a-form-model-item>
          <a-form-model-item label="密码" prop="password">
            <a-input v-model="loginForm.password" type="password" />
          </a-form-model-item>
        </a-form-model>
        <a-button type="primary" block @click="doLogin">登录</a-button>
        <a-row id="forgetPwd"><a href="#/forgetPwd">忘记密码?</a></a-row>
      </a-tab-pane>

      <!-- 注册 -->
      <a-tab-pane key="2" tab="注册" force-render>
        <a-form-model
          ref="registerForm"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          :model="registerForm"
          :rules="registerRules"
        >
          <a-form-model-item label="邮箱" prop="email">
            <a-input v-model="registerForm.email" />
          </a-form-model-item>
          <a-form-model-item label="真实姓名" prop="name">
            <a-input v-model="registerForm.name" />
          </a-form-model-item>
          <a-form-model-item label="密码" prop="password1">
            <a-input v-model="registerForm.password1" type="password" />
          </a-form-model-item>
          <a-form-model-item label="确认密码" prop="password2">
            <a-input v-model="registerForm.password2" type="password" />
          </a-form-model-item>
        </a-form-model>
        <a-button type="primary" block @click="doRegister">注册</a-button>
      </a-tab-pane>
      <a-tab-pane key="3" tab="扫码登陆" force-render>
        <div style="height: 30rem; padding: 2rem 0 0 2.5rem" id="wx_login"></div>
      </a-tab-pane>
    </a-tabs>
    </div>
    <!-- footer -->
    <div class="footer">
      <p>上勘院大数据中心</p>
      <p>
        <span>
          <a href="http://www.sgidi.com"
            >上海勘察设计研究院（集团）有限公司 版权所有</a
          ><span></span>
        </span>
        <a href="https://beian.miit.gov.cn/#/Integrated/index"
          >&nbsp;沪ICP备18029600号</a
        >
      </p>
      <p>
        地址：上海市杨浦区水丰路38号&nbsp;电话：86-21-65059968&nbsp;传真：86-21-65059958&nbsp;邮编：200093
      </p>
    </div>
  </div>
</template>

<script>
import util from '../util.js'
// import cfg from '../../config'
export default {
  name: 'Login',
  data: function() {
    const checkPwd2 = (rule, value, callback) => {
      if (value !== this.registerForm.password1) {
        return callback(new Error('两次密码不一致'))
      } else {
        return callback()
      }
    }
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      loginForm: { email: '', password: '' },
      loginRules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur', min: 3 }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },

      registerForm: { email: '', name: '', password1: '', password2: '' },
      registerRules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: util.checkEmail, tirgger: 'change' }
        ],
        name: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
        password1: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: util.checkPwd, tirgger: 'change' }
        ],
        password2: [
          { required: true, message: '请重新输入确认密码', trigger: 'blur' },
          { validator: checkPwd2, tirgger: 'change' }
        ]
      }
    }
  },
  methods: {
    async doLogin() {
      const validate = await this.$refs.loginForm.validate()
      if (!validate) {
        return ''
      }
      const resp = await this.$http.post(
        'token',
        'username=' +
          this.loginForm.email +
          '&password=' +
          this.loginForm.password,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      )
      if (resp.status === 200) {
        this.$http.defaults.headers.common.Authorization =
          'Bearer ' + resp.data.access_token
        localStorage.setItem('accessToken', resp.data.access_token)
        this.$router.push('/instances')
        if (resp.data.is_admin) {
          this.$store.commit('userIsAdmin')
        }
        localStorage.setItem('uname', resp.data.uname)
        // this.$store
      } else {
        var msg = util.errMsg(resp, '注册失败，请重新注册')
        this.$message.error(msg)
      }
    },
    async doRegister() {
      const validate = await this.$refs.registerForm.validate()
      if (!validate) {
        return ''
      }
      const resp = await this.$http.post('register', this.registerForm)
      if (resp.status === 200) {
        this.$message.success('注册成功，请注意查收邮件')
      } else {
        var msg = util.errMsg(resp, '注册失败，请重新注册')
        this.$message.error(msg)
      }
    }
  },
  mounted() {
    window.WwLogin({
      id: 'wx_login',
      appid: 'ww357607529ba12a31', // appid
      agentid: '1000012', // agentid
      redirect_uri: 'http://suan.sgidi.top/qywx_login', // 回调地址，注意回调地址需要进行urlencode
      state: '', // 用于保持请求和回调的状态，授权请求后原样带回给企业。该参数可用于防止csrf攻击,参数非必填
      scope: 'snsapi_privateinfo'
    })
  }
}
</script>

<style lang="less" scoped>
// #page {
//   min-height: 100rem;
//   // min-width: 100rem;
// }
.head {
  text-align: center;
  font-weight: bold;
  font-size: 2rem;
  margin-bottom: 2rem;
  letter-spacing: 0.6rem;
  z-index: 10;
}
.img {
  background-size: 30rem;
  background-repeat: no-repeat;
  width: 30rem;
  height: 30rem;
  position: absolute;
  opacity: 0.6;
  // z-index: 2;
}
#logo {
  background-size: 20rem;
  opacity: 1;
  background-image: url(../assets/img/logo.png);
  left: 0rem;
  top: 0rem;
}
#login_tab {
  width: 28rem;
  padding: 1rem 2rem 2rem 2rem;
  background-color: white;
  // margin: auto;
  box-shadow: 6px 6px 8px #999;
  border: lightgray solid 1px;
}
#forgetPwd {
  padding-top: 1.5rem;
  text-align: right;
}
#mainTab{
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  margin-top: -5rem;
}
.footer {
  position: absolute;
  font-size: 0.6rem;
  bottom: 0rem;
  left: 0rem;
  text-align: center;
  background-color: darkslateblue;
  padding: 0.5rem 0 0 0;
  width: 100%;
  color: lightgray;
  line-height: 0.6rem;
  a {
    color: lightgray;
  }
}
</style>
